const _i18n_error = {
  count: {
    EN: `no have online agent `,
    KO: `no have online agent `,
    JP: `オンラインのエージェントはいません`
  },
  test_error : {
    EN: `Test check request failed.`,
    KO: `Test check request failed.`,
    JP: `テストチェックのリクエストが失敗しました。`
  }
}

const i18n_toastr = {
  _i18n_error
}

export default i18n_toastr